import { updateIntl } from 'react-intl-redux';
import ServerEquipment from '../server/serverEquipment';

export const SET_WINDOW_SIZE_CHANGE = 'SET_WINDOW_SIZE_CHANGE'; //窗口大小有改变
export const SET_DESKTOP_TYPE = 'SET_DESKTOP_TYPE';
export const SET_USER_LOGIN = 'SET_USER_LOGIN';
export const SET_ERROR_MSG = 'SET_ERROR_MSG';
export const SET_DIALOG_MSG = 'SET_DIALOG_MSG';
export const SET_CYSIZE = 'SET_CYSIZE';
export const SET_VPNTOPOLOGYDATA = 'SET_VPNTOPOLOGYDATA';
export const SET_VPNTOPOLOGYSTATUS = 'SET_VPNTOPOLOGYSTATUS';
export const SET_MANAGER_SERVER_IP = 'SET_MANAGER_SERVER_IP';
export const SET_MANAGER_SERVER_PORT = 'SET_MANAGER_SERVER_PORT';
export const SET_PROXY_SERVER_LIST = 'SET_PROXY_SERVER_LIST';
export const SET_MANAGER_SERVER_SESSIONID = 'SET_MANAGER_SERVER_SESSIONID';
export const SET_HINT_DIALOG_INFO = 'SET_HINT_DIALOG_INFO'; //设置提示窗口的信息
export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE';
export const SET_DASHBOARD_ITEMS = 'SET_DASHBOARD_ITEMS';

export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';  //loading 状态
export const SET_SUBSIDECOLLAPSED = 'SET_SUBSIDECOLLAPSED';

export const SET_BREAKPOINT = 'SET_BREAKPOINT';

export function setSubSideCollapsed(subSideCollapsed) {
  return {
    type: SET_SUBSIDECOLLAPSED,
    subSideCollapsed
  }
}

export function setLoadingStatus(loadingStatus){
  return {
    type: SET_LOADING_STATUS,
    loadingStatus
  }
}

export function getUserIP(){
  return (dispatch, getState) => {
    ServerEquipment.getUserIP(function(data) { });
  }
}

// update locale
export function updateLocale(value){
  return (dispatch, getState) => {
    value = value || getState().intl.locale;
    const locales = getState().locales;
    dispatch(updateIntl({
      locale: value,
      messages: locales[value] ? locales[value].messages : locales['en'].messages
    }))
  }
}

export function setWindowSizeChange(windowSizeChange) {
    return {
        type: SET_WINDOW_SIZE_CHANGE,
        windowSizeChange
    }
}

export function setDesktopType(desktopType) {
    return {
        type: SET_DESKTOP_TYPE,
        desktopType
    }
}

export function setUserLogin(userLogin) {
    return {
        type: SET_USER_LOGIN,
        userLogin
    }
}

export function setErrorMsg(errorMsg) {
    return {
        type: SET_ERROR_MSG,
        errorMsg
    }
}

export function setDialogMsg(dialogMsg) {
    return {
        type: SET_DIALOG_MSG,
        dialogMsg
    }
}

export function setCySize(cySize) {
    return {
        type: SET_CYSIZE,
        cySize
    }
}

export function setVpnTopologyData(vpntopologyData) {
    return {
        type: SET_VPNTOPOLOGYDATA,
        vpntopologyData
    }
}

export function setVpnTopologyStatus(vpntopologyStatus) {
    return {
        type: SET_VPNTOPOLOGYSTATUS,
        vpntopologyStatus
    }
}

export function setManagerServerIP(managerServerIP) {
    return {
        type: SET_MANAGER_SERVER_IP,
        managerServerIP
    }
}

export function setManagerServerPort(managerServerPort) {
    return {
        type: SET_MANAGER_SERVER_PORT,
        managerServerPort
    }
}

export function setProxyServerList(proxyServerList) {
    return {
        type: SET_PROXY_SERVER_LIST,
        proxyServerList
    }
}

export function setManagerServerSessionId(managerServerSessionId) {
    return {
        type: SET_MANAGER_SERVER_SESSIONID,
        managerServerSessionId
    }
}

export function setHintDialogInfo(hintDialogInfo) {
    return {
        type: SET_HINT_DIALOG_INFO,
        hintDialogInfo
    }
}

export function setWindowSize(windowSize) {
    return {
        type: SET_WINDOW_SIZE,
        windowSize
    }
}

export function setDashboardItems(dashboardItems) {
    return {
        type: SET_DASHBOARD_ITEMS,
        dashboardItems
    }
}

export function setBreakPoint(breakPoint) {
  return {
    type: SET_BREAKPOINT,
    breakPoint
  }
}